import { Globe2 } from "lucide-react";

const MARKETS = [
  { code: "AE", name: "U.A.E.", port: "Jebel Ali" },
  { code: "CN", name: "China", port: "Shanghai · Qingdao" },
  { code: "IN", name: "India", port: "Mundra · Nhava Sheva" },
  { code: "TR", name: "Türkiye", port: "Istanbul" },
  { code: "DE", name: "Germany", port: "Hamburg" },
  { code: "OM", name: "Oman", port: "Sohar" },
  { code: "PK", name: "Pakistan", port: "Karachi" },
  { code: "JP", name: "Japan", port: "Yokohama" },
];

export default function GlobalReach() {
  return (
    <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20 lg:py-24" data-testid="home-global-reach">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
        <div>
          <p className="label-eyebrow flex items-center gap-2">
            <Globe2 size={14} className="copper-text" /> / Global Reach
          </p>
          <h2 className="font-heading mt-3 text-3xl md:text-5xl font-black uppercase tracking-tighter">
            Buyers across <br /> four continents.
          </h2>
        </div>
        <p className="text-zinc-400 max-w-md text-sm leading-relaxed">
          Material shipped via Dar es Salaam, Walvis Bay and Beira to refiners,
          smelters and licensed traders across Asia, the Middle East and Europe.
        </p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-px bg-zinc-800 border border-zinc-800">
        {MARKETS.map((m, i) => (
          <div
            key={m.code}
            data-testid={`home-market-${m.code.toLowerCase()}`}
            className="bg-[var(--eel-surface)] p-6 hover:bg-[#1c1c1f] transition-colors"
          >
            <div className="flex items-baseline justify-between">
              <span className="font-heading text-3xl font-black copper-text">
                {m.code}
              </span>
              <span className="label-eyebrow text-zinc-600">
                {String(i + 1).padStart(2, "0")}
              </span>
            </div>
            <p className="mt-4 font-heading text-base font-bold uppercase">
              {m.name}
            </p>
            <p className="mt-1 text-xs text-zinc-500 uppercase tracking-widest">
              {m.port}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
